<template>
  <section class="email">
    <Header :user="user" />
    <main class="main"  :class="{ 'expand-main' : isMenuCollapse }">
      <component :is="emailsTabComponent" 
      @refresh="refresh" :key="keycomp" :selectedEmailId="selectedEmailId" :selectedEmailSubject="selectedEmailSubject"></component>
      <LoadingSpinner v-if="loading" />
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import AllEmails from "@/components/Emails/AllEmails.vue";
import SpamEmail from "@/components/Emails/SpamEmail.vue";
import EmailView from "@/components/Emails/EmailView.vue";
import EmailThread from "@/components/Emails/EmailThread.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  created() {
    this.changeHeaderTab({ tab: "ALL" });
    if (typeof this.$route.params.id !== "undefined") {
      this.changeHeaderTab({ tab: "SELECTED" });
    }
  },
  data(){
    return {
      keycomp:233223,
    }
  },
  components: {
    SpamEmail,
    AllEmails,
    EmailView,
    EmailThread,
    LoadingSpinner
  },
   mounted(){
    window.onbeforeunload  = null;
    this.udpdateHeader(this.$route.name);
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      loading: state => state.emails.loading,
    }),

    user() {
      return this.$store.state.authentication.user;
    },

    emailsTabComponent() {
      if (this.headerTab === "ALL") {
        if(this.user.role_id == 1){
          return "AllEmails";
        }else{
          return "SpamEmail"
        }
      } else if (this.headerTab === "THREAD") {
        return "EmailThread";
      } else {
        return "EmailView";
      }
    },
    selectedEmailSubject(){
        return this.$route.params.subject;
    },

    selectedEmailId() {
      return this.$route.params.id;
    }
  },

  methods: {
    refresh(){
      this.keycomp++
    },
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
     udpdateHeader(route){
      this.setCurrentRoute({page:route});
      this.setCurrentRouteChild({child:''});
    }
  }
};
</script>
